module.exports = __webpack_public_path__ + "public/images/loyalty-bg.3a5577e3aceda03204d6d9d359b80a2d.svg";